module.exports = {"TXTWCL_Something_went_wrong":{"id":"TXTWCL_Something_went_wrong","defaultMessage":"Er is iets fout gegaan","track":"Something went wrong"}}